import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import './App.css';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">

      {/* ── Hero ── */}
      <section className="hero-section">
        <div className="hero-left">
          <div className="hero-tag">⚙ Industrial CPQ &amp; Configurator Platform</div>
          <h1 className="hero-title">
            Configure. Quote.<br />
            <span>Win More Business.</span>
          </h1>
          <p className="hero-subtitle">
            Precision parametric configurators for industrial sensors, mechanical components,
            and engineered systems. Built for engineering and procurement teams who need
            accurate specs and real-time pricing.
          </p>
          <div className="hero-cta-group">
            <button className="hero-cta-primary" onClick={() => navigate('/3d-configurator')}>
              Open Sensor Configurator →
            </button>
            <button className="hero-cta-secondary" onClick={() => navigate('/gears')}>
              Gear Designer
            </button>
          </div>
        </div>

        <div className="hero-right">
          <img src="/hero.png" alt="IndustriQuote platform screenshot" className="hero-image" />
        </div>
      </section>

      {/* ── Modules ── */}
      <section className="modules-section">
        <div className="modules-label">Sample Modules</div>
        <p className="modules-description">
          These demos showcase a small selection of what we can implement. Every configurator is custom-engineered for your product line, pricing logic, and workflow. We work directly with manufacturers to design tools that accelerate quoting and reduce sales and engineering back-and-forth.
        </p>
        <div className="card-grid">

          <div className="premium-card" onClick={() => navigate('/3d-configurator')}>
            <div style={{ fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9ca3af' }}>
              Module 1
            </div>
            <img src="/3d_configurator_sample.png" alt="3D WaveMaster Sensor Configurator" className="card-thumbnail" />
            <h2>3D WaveMaster Sensor Configurator</h2>
            <p>Configure guided wave radar level sensors for complex process applications. Select probe type, mounting, thermal profile, and generate a certified model number.</p>
            <div className="card-action">Open Configurator →</div>
          </div>

          <div className="premium-card" onClick={() => navigate('/engineering-drawing')}>
            <div style={{ fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9ca3af' }}>
              Module 2
            </div>
            <img src="/2d_drawing_sample.png" alt="2D Engineering Drawing Template" className="card-thumbnail" />
            <h2>2D Engineering Drawing Template</h2>
            <p>Automatically generate standard ISO A3 engineering drawing templates. A robust starting point for automated 2D drafting and documentation.</p>
            <div className="card-action">Open Template →</div>
          </div>

          <div className="premium-card" onClick={() => navigate('/gears')}>
            <div style={{ fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9ca3af' }}>
              Module 3
            </div>
            <img src="/3d_gear_sample.png" alt="Parametric Gear Designer" className="card-thumbnail" />
            <h2>Parametric Gear Designer</h2>
            <p>Generate exact involute 3D spur, helical, and rack gears. Fully customizable geometry, bore, hub, and meshing pair configuration with STL export.</p>
            <div className="card-action">Open Configurator →</div>
          </div>


        </div>
      </section>

      {/* ── How It Works Preview ── */}
      <section className="home-preview-section">
        <div className="preview-container">
          <div className="preview-content">
            <div className="modules-label">Process</div>
            <h2 className="preview-title">How It Works</h2>
            <p className="preview-description">
              IndustriQuote converts complex product logic into structured configurators that generate accurate outputs instantly.
            </p>
            <ul className="preview-list">
              <li><span>1</span> Define product rules and constraints</li>
              <li><span>2</span> Build a guided configuration experience</li>
              <li><span>3</span> Generate pricing, models, and documentation in real time</li>
              <li><span>4</span> Integrate with your internal systems</li>
            </ul>
            <p className="preview-note">
              Every step is engineered to eliminate manual quoting and reduce back-and-forth between sales and engineering.
            </p>
            <button className="hero-cta-secondary" onClick={() => navigate('/how-it-works')}>
              View Full Process →
            </button>
          </div>
        </div>
      </section>

      {/* ── About Preview ── */}
      <section className="home-preview-section about-preview-bg">
        <div className="preview-container">
          <div className="preview-content">
            <div className="modules-label">Company</div>
            <h2 className="preview-title">About IndustriQuote</h2>
            <p className="preview-description">
              IndustriQuote builds engineering-first CPQ systems for industrial manufacturers with complex, configurable products.
            </p>
            <p className="preview-description">
              We replace spreadsheets and manual validation with deterministic logic that ensures every configuration is valid, priced correctly, and production-ready.
            </p>
            <p className="preview-note">
              Built for teams that need precision, speed, and scalability.
            </p>
            <button className="hero-cta-primary" onClick={() => navigate('/about')}>
              Learn More →
            </button>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <Footer />

    </div>
  );
};

export default Home;
